/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_On_Size_NoteInputs */

const en_wc_on_size_note = /** @type {(inputs: Wc_On_Size_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The editor and its fonts download on first use, then your browser caches them.`)
};

/**
* | output |
* | --- |
* | "The editor and its fonts download on first use, then your browser caches them." |
*
* @param {Wc_On_Size_NoteInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_on_size_note = /** @type {((inputs?: Wc_On_Size_NoteInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_On_Size_NoteInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_on_size_note(inputs)
});
export { wc_on_size_note as "wc.on.size_note" }